<script setup lang="ts"></script>

<template>
  <div class="context-menu-item-group">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.context-menu-item-group {
  display: grid;
}
</style>
